/* eslint-disable no-unused-vars */
import { axios } from '../index'

import coupon_available from '@/jsons-data/mocks/coupon_available.json'
import coupon_stay_mapping from '@/jsons-data/mocks/coupon_stay_mapping.json'
import coupon_icons from '@/jsons-data/mocks/coupon_icons.json'


export default {

  getSubsidyCouponList(params) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(coupon_available.availableDataList || [])
      }, 500)
    })
  },

  validateUseCoupon(data) {
    // {
    //   "reservationInfo": [
    //     {
    //       "subsidyId": "string",
    //       "customerNo": "string",
    //       "subsidyDetailId": "string",
    //       "priceId": "string",
    //       "personAccompanyFlag": "string",
    //       "minimamTargetAge": 0,
    //       "degreeCount": "string",
    //       "useScheduleDateTime": "string",
    //       "acptDtlNo": "string",
    //       "company_cd": "string",
    //       "subscription_id": 0,
    //       "relationshipCd": "string",
    //       "couponId": "string"
    //     }
    //   ],
    //   "applyTargetAmount": 0
    // }
    return new Promise((resolve, reject) => {
      axios.post('/sbsd/available/check', data).then(
        () => {
          resolve({
            result: 'ok',
            errorCode: '',
            errorMessage: ''
          })
        },
        (error) => {
          // reject(error?.error)
          // reject({
          //   status: '',
          //   data: {
          //     errorResponseList: [
          //       {
          //         errorCode: 'A',
          //         errorDetail: 'A'
          //       },
          //       {
          //         errorCode: 'B',
          //         errorDetail: 'B'
          //       }
          //     ]
          //   }
          // })
          resolve({
            result: 'ok',
            errorCode: '',
            errorMessage: ''
          })
        }
      )
    })
  },

  getStationMapping(params) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(coupon_stay_mapping)
      }, 500)
    })
  },

  getIcons(params) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(coupon_icons)
      }, 500)
    })
  }
}